export default __webpack_public_path__ + "static/media/annalise.2f8bd388.webm";